enum SignatureType {
    Application = 1,
}

export default SignatureType;
